// Runs promises, providing an abort signal. If a second promise is dispatched,
// the previous pending promise gets aborted.
//
// If waitForRejection is set, wait for the prior promise to furfill before
// starting a new one.
export function useAbortFn<F extends (...args: any) => any>(
  fn: (signal: AbortSignal, ...args: Parameters<F>) => ReturnType<F>,
  waitForRejection: boolean = false
): (...args: Parameters<F>) => Promise<ReturnType<F>> {
  let activePromise = undefined as Promise<ReturnType<F>> | undefined;
  let activeController = undefined as AbortController | undefined;

  return async (...args) => {
    if (activePromise !== undefined && activeController !== undefined) {
      activeController.abort();
      if (waitForRejection) {
        try {
          await activePromise;
        } catch (error) {
          if (!(error instanceof DOMException && error.name === "AbortError")) {
            throw error;
          }
        }
      }
    }

    activeController = new AbortController();
    activePromise = Promise.resolve(fn(activeController.signal, ...args));
    return await activePromise;
  };
}
